import styled from 'styled-components';

const AntCheckbox = ComponentName => styled(ComponentName)`
  &.ant-checkbox-wrapper {
    font-size: 13px;
    color: #595959;

    .ant-checkbox-checked .ant-checkbox-inner,
    .ant-checkbox-indeterminate .ant-checkbox-inner {
      background-color: #00598d;
      border-color: #00598d;
    }

    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #00598d;
    }

    &:hover {
      .ant-checkbox-inner {
        border-color: #00598d;
      }
    }
  }
`;

export default AntCheckbox;


// WEBPACK FOOTER //
// ./src/components/UI/styles/checkbox.style.js